module.exports = __webpack_public_path__ + "static/media/emo4b.adb91c79.png";